var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58884 0 0 3.58884 0 8C0 12.4112 3.58884 16 8 16C12.4112 16 16 12.4112 16 8C16 3.58884 12.4112 0 8 0ZM12.4343 6.37008L7.32506 11.4794C7.16956 11.6349 6.95403 11.7241 6.73418 11.7241V12.0701L6.72675 11.7241C6.50396 11.7222 6.28757 11.6291 6.13293 11.4688L3.55529 8.79706C3.23529 8.46547 3.2448 7.93565 3.57639 7.61565C3.73293 7.46448 3.93894 7.38145 4.15637 7.38145C4.38521 7.38145 4.59883 7.47209 4.75779 7.63676L6.74491 9.69635L11.2529 5.1885C11.4107 5.03075 11.6205 4.94374 11.8438 4.94374C12.0669 4.94374 12.2768 5.03057 12.4345 5.18832C12.76 5.51421 12.76 6.04437 12.4343 6.37008Z",
    fill: "#76CD75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.56afcc790222cd0d985d772693f2c8fe.svg";
export { ForwardRef as ReactComponent };